import styled, { css } from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/toyotaTheme";
import type { ContainerVariantsType } from "./Container";

// STYLES
const container = css`
    display: flex;
    /* flex-wrap: wrap; */
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    max-width: 100%;
    margin-inline: auto;

    @media screen and (min-width: ${breakpoints.xxxl}) {
        margin-inline: 0;
    }

    @media screen and (min-width: ${breakpoints.max}) {
        margin-inline: auto;
        max-width: 1444px;
    }

    @supports not (margin-inline: auto) {
        @media screen and (min-width: ${breakpoints.max}) {
            margin-left: auto;
            margin-right: auto;
        }
    }
`;

const containerReverse = css`
    ${container};
    flex-direction: row-reverse;
`;

// COMPONENTS
export const ContainerVariants = {
    container,
    "container-reverse": containerReverse,
};

const ContainerVariant = styled.div<{ variant: ContainerVariantsType }>`
    ${(props) =>
        props.variant &&
        css`
            ${ContainerVariants[props.variant]}
        `};
`;

export default ContainerVariant;
